function initializeBeforeAfterSlider(slider) {
  const wrapper = slider.querySelector('.slider-wrapper');
  const handle = slider.querySelector('.slider-handle');
  const overlayDiv = slider.querySelector('.slider-overlay');
  
  if (!wrapper || !handle || !overlayDiv) return;
  
  let isDragging = false;
  let currentPosition = 50;
  
  
  const newWrapper = wrapper.cloneNode(true);
  wrapper.parentNode.replaceChild(newWrapper, wrapper);
  
  const newHandle = newWrapper.querySelector('.slider-handle');
  const newOverlayDiv = newWrapper.querySelector('.slider-overlay');
  
  function setSliderPosition(percentage, animate = false) {
    if (animate) {
      newOverlayDiv.style.transition = 'width 0.3s ease-out';
      newHandle.style.transition = 'left 0.3s ease-out';
    } else {
      newOverlayDiv.style.transition = 'none';
      newHandle.style.transition = 'none';
    }
    
    newOverlayDiv.style.width = percentage + '%';
    newHandle.style.left = percentage + '%';
    
    // Scale the overlay image so it shows the same portion as the background
    const overlayImg = newOverlayDiv.querySelector('img');
    if (overlayImg && percentage > 0) {
      overlayImg.style.width = (100 / percentage * 100) + '%';
    }
    
    const leftBadge = slider.querySelector('.badge.left');
    const rightBadge = slider.querySelector('.badge.right');
    
    if (leftBadge) {
      if (percentage <= 10) {
        leftBadge.style.opacity = '0';
      } else if (percentage <= 20) {
        const opacity = (percentage - 10) / 10;
        leftBadge.style.opacity = opacity.toString();
      } else {
        leftBadge.style.opacity = '1';
      }
    }
    
    if (rightBadge) {
      if (percentage >= 90) {
        rightBadge.style.opacity = '0';
      } else if (percentage >= 80) {
        const opacity = (90 - percentage) / 10;
        rightBadge.style.opacity = opacity.toString();
      } else {
        rightBadge.style.opacity = '1';
      }
    }
  }
  
  // Set initial position to center
  setSliderPosition(currentPosition);
  
  // Mouse events for click/drag behavior
  newWrapper.addEventListener('mousedown', (e) => {
    isDragging = true;
    newWrapper.classList.add('active');
    updateSlider(e.pageX);
    e.preventDefault();
  });
  
  document.addEventListener('mousemove', (e) => {
    if (isDragging) {
      updateSlider(e.pageX);
    }
  });
  
  document.addEventListener('mouseup', () => {
    if (isDragging) {
      isDragging = false;
      newWrapper.classList.remove('active');
      snapToNearestPosition();
    }
  });
  
  // Touch events for mobile
  newWrapper.addEventListener('touchstart', (e) => {
    isDragging = true;
    newWrapper.classList.add('active');
    updateSlider(e.touches[0].pageX);
    e.preventDefault();
  });
  
  newWrapper.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    updateSlider(e.touches[0].pageX);
  });
  
  newWrapper.addEventListener('touchend', () => {
    if (isDragging) {
      isDragging = false;
      newWrapper.classList.remove('active');
      snapToNearestPosition();
    }
  });
  
  function updateSlider(x) {
    const rect = newWrapper.getBoundingClientRect();
    const position = x - rect.left;
    const percentage = Math.max(0, Math.min(100, (position / rect.width) * 100));
    
    currentPosition = percentage;
    setSliderPosition(percentage);
  }
  
  function snapToNearestPosition() {
    // Find the nearest snap point (left: 0%, center: 50%, right: 100%)
    const snapPoints = [0, 50, 100];
    let nearestSnap = snapPoints[0];
    let minDistance = Math.abs(currentPosition - snapPoints[0]);
    
    for (let i = 1; i < snapPoints.length; i++) {
      const distance = Math.abs(currentPosition - snapPoints[i]);
      if (distance < minDistance) {
        minDistance = distance;
        nearestSnap = snapPoints[i];
      }
    }
    
    // Always snap to the nearest position
    currentPosition = nearestSnap;
    setSliderPosition(nearestSnap, false);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.before-after-slider');
  sliders.forEach(initializeBeforeAfterSlider);
});

class BeforeAfterCarousel {
  constructor(section) {
    this.section = section;
    this.slides = section.querySelectorAll('.before-after-carousel__slide');
    this.navItems = section.querySelectorAll('.before-after-carousel__nav-item');
    this.prevButtons = section.querySelectorAll('.carousel-button.prev');
    this.nextButtons = section.querySelectorAll('.carousel-button.next');
    this.navigations = section.querySelectorAll('.before-after-carousel__navigation');
    this.tooltips = section.querySelectorAll('img.tooltip');
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    
    this.init();
  }
  
  init() {
    if (this.totalSlides <= 1) {
      this.prevButtons.forEach(btn => btn?.remove());
      this.nextButtons.forEach(btn => btn?.remove());
      this.navigations.forEach(nav => nav?.remove());
      return;
    }
    
    this.prevButtons.forEach(btn => {
      btn?.addEventListener('click', () => this.goToPrevSlide());
    });
    
    this.nextButtons.forEach(btn => {
      btn?.addEventListener('click', () => this.goToNextSlide());
    });
    
    // Add event listeners to all navigation items in both desktop and mobile
    this.navigations.forEach(navigation => {
      const navItems = navigation.querySelectorAll('.before-after-carousel__nav-item');
      navItems.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          const slideIndex = parseInt(item.getAttribute('data-slide-to'));
          if (!isNaN(slideIndex)) {
            this.goToSlide(slideIndex);
          }
        });
      });
    });
    this.tooltips.forEach((tooltip) => {
      const text = tooltip.parentElement.querySelector('.metafield-rich_text_field');
      if (text) {
        text.appendChild(tooltip);
        tooltip.classList.remove('inactive');
      }
    })
    this.updateCarousel();
  }
  
  goToPrevSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    this.updateCarousel();
  }
  
  goToNextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    this.updateCarousel();
  }
  
  goToSlide(index) {
    if (index < 0 || index >= this.totalSlides) return;
    this.currentSlide = index;
    this.updateCarousel();
  }
  
  updateCarousel() {
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('active', index === this.currentSlide);
    });
    
    // Update both desktop and mobile navigation separately
    this.navigations.forEach(navigation => {
      const navItems = navigation.querySelectorAll('.before-after-carousel__nav-item');
      navItems.forEach((item, index) => {
        item.classList.toggle('active', index === this.currentSlide);
      });
    });
    
    this.scrollNavIntoView();
    
    setTimeout(() => {
      this.reinitializeSliders();
    }, 50);
  }
  
  reinitializeSliders() {
    const activeSlide = this.slides[this.currentSlide];
    if (!activeSlide) return;
    
    const slider = activeSlide.querySelector('.before-after-slider');
    if (!slider) return;
    
    // Reset any existing inline styles on the slider before reinitializing
    const wrapper = slider.querySelector('.slider-wrapper');
    const overlayDiv = slider.querySelector('.slider-overlay');
    const handle = slider.querySelector('.slider-handle');
    
    if (wrapper) {
      wrapper.classList.remove('active');
    }
    
    if (overlayDiv) {
      overlayDiv.style.width = '';
      overlayDiv.style.transition = '';
      const overlayImg = overlayDiv.querySelector('img');
      if (overlayImg) {
        overlayImg.style.width = '';
        overlayImg.style.transition = '';
      }
    }
    
    if (handle) {
      handle.style.left = '';
      handle.style.transition = '';
    }
    
    initializeBeforeAfterSlider(slider);
  }
  
  scrollNavIntoView() {
    this.navigations.forEach(navigation => {
      if (!navigation) return;
      
      const activeNavItem = navigation.querySelector('.before-after-carousel__nav-item.active');
      if (!activeNavItem) return;
      
      const navRect = navigation.getBoundingClientRect();
      const itemRect = activeNavItem.getBoundingClientRect();
      
      const isOutOfView = itemRect.left < navRect.left || itemRect.right > navRect.right;
      
      if (isOutOfView) {
        const scrollLeft = activeNavItem.offsetLeft - (navRect.width / 2) + (itemRect.width / 2);
        
        navigation.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const carouselSections = document.querySelectorAll('.before-after-carousel');
    carouselSections.forEach(section => {
      new BeforeAfterCarousel(section);
    });
  }, 100);
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  if (section.classList.contains('before-after-carousel')) {
    new BeforeAfterCarousel(section);
  }
});